import { RouterStore } from 'mobx-react-router';
import React from 'react';
import { rootStore } from './common/store/root-store';

export const routingStore = new RouterStore();
export const storesContext = React.createContext({
  rootStore,
  routingStore,
});
